module.exports = __webpack_public_path__ + "img/roll2.c9172a96.png";